<!--
The element provides a tooltip with a message
displayed by `.showMessage(text, ttl)` method call.
-->
<template>
  <Tooltip ref="tooltip" placement="bottom" :options="{ trigger: 'manual' }">
    <template #trigger>
      <div><slot name="target" /></div>
    </template>
    <template #tooltip>
      <div>{{ text }}</div>
    </template>
  </Tooltip>
</template>

<script>
import Tooltip from "./Tooltip.vue";

export default {
  components: { Tooltip },
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  methods: {
    show() {
      const { tippyRef } = this.$refs.tooltip;
      tippyRef.show();
      setTimeout(() => {
        tippyRef.hide();
      }, 3000);
    }
  }
};
</script>
